import { useCallback } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import {
  parseConfirmFlowOrigin,
  resolveConfirmBackNavigation,
} from '@src/features/order/navigation';

export function useConfirmOrderBack(missionId: string | undefined) {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  return useCallback(() => {
    const origin = parseConfirmFlowOrigin(searchParams);
    const orderId = searchParams.get('orderId');
    const { path, replace } = resolveConfirmBackNavigation(origin, missionId, orderId);
    navigate(path, { replace });
  }, [searchParams, missionId, navigate]);
}
